'use client'

import React, { cloneElement, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Text } from '@chakra-ui/react'

import { RightArrowButton } from 'app/components/shared/Buttons/RightArrowButton'

type Props = {
  title: string
  description: string
  url: string
  image: string
  color: string
  icon: React.ReactElement<any>
}

export const SafeWithLeid = ({ title, description, url, image, color, icon }: Props): JSX.Element => {
  const [isHovered, setIsHovered] = useState(false)
  const { t } = useTranslation(['common'])
  return (
    <Box height="100%" onClick={() => window.open(url, '_blank', 'noopener,noreferrer')} maxWidth="400px" width="100%">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="100%"
        backgroundColor="leidTheme.20"
        gap="24px"
        borderRadius={{ base: '28px', md: '40px' }}
        padding={{ base: '16px', md: '24px' }}
        cursor="pointer"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          backgroundColor={isHovered ? 'updatedLeid.peach' : color}
          transition="all 0.3s ease-in-out"
          width="100%"
          height="288px"
          borderRadius={{ base: '18px', md: '28px' }}
          overflow="hidden"
        >
          <Box
            style={{
              backgroundImage: `url(${image})`,
              mixBlendMode: 'luminosity',
              scale: isHovered ? '1.1' : '1',
              transition: 'all 0.3s ease-in-out',
              width: '100%',
              height: '100%',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            }}
          ></Box>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          backgroundColor="transparent"
          width="100%"
          borderRadius="28px"
          alignItems="flex-start"
          gap="16px"
          position="relative"
        >
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="8px"
            justifyContent="space-between"
            width="100%"
          >
            <Text as="h2" fontSize="xl" fontWeight="semibold" color="black" textAlign="left">
              {title}
            </Text>
            <Box position="relative">
              {icon &&
                cloneElement(icon, {
                  color: color,
                  style: {
                    scale: isHovered ? '1.2' : '1',
                    transition: 'all 0.3s ease-in-out',
                  },
                })}
            </Box>
          </Box>
          <Text color="gray.500">{description}</Text>
          <RightArrowButton text={t('readMore')} url={url} />
        </Box>
      </Box>
    </Box>
  )
}
